import { useScrollReveal, animStyle } from '../../../hooks/useScrollReveal';

const clients: { name: string; logo: string | null; url: string }[] = [
  { name: '株式会社ループス・コミュニケーションズ', logo: null, url: 'http://www.looops.net/' },
  { name: '日本マイクロソフト株式会社', logo: null, url: 'https://www.microsoft.com/ja-jp' },
  { name: 'ヤマハ株式会社', logo: null, url: 'https://jp.yamaha.com/' },
  { name: 'ボルボ・カー・ジャパン株式会社', logo: null, url: 'https://www.volvocars.com/jp' },
  { name: 'Hong Kong Express Airways Limited', logo: null, url: 'https://www.hkexpress.com/ja' },
  { name: '株式会社クリエイティブマンプロダクション', logo: null, url: 'https://www.creativeman.co.jp/' },
  { name: '株式会社フィリップス・ジャパン', logo: null, url: 'https://www.philips.co.jp/' },
  { name: 'ドキュサイン・ジャパン株式会社', logo: null, url: 'https://www.docusign.jp/' },
  { name: 'SAPジャパン株式会社', logo: null, url: 'https://www.sap.com/japan/index.html' },
  { name: '株式会社ソニー・ミュージックソリューションズ', logo: null, url: 'https://www.m-on.jp/' },
  { name: 'トレジャーデータ株式会社', logo: null, url: 'https://www.treasuredata.com/jp/' },
  { name: 'ServiceNow Japan合同会社', logo: null, url: 'https://www.servicenow.com/jp/' },
  { name: 'ソニーセミコンダクタソリューションズ株式会社', logo: null, url: 'https://www.sony-semicon.com/' },
  { name: '損害保険ジャパン株式会社', logo: null, url: 'https://www.sompo-japan.co.jp/' },
  { name: '工機ホールディングスジャパン株式会社', logo: null, url: 'https://www.koki-holdings.co.jp/' },
  { name: '株式会社レッドバロン', logo: null, url: 'https://www.redbaron.co.jp/' },
  { name: 'VML & Ogilvy Japan 合同会社', logo: null, url: 'https://www.vml.com/' },
  { name: 'インパクトM株式会社', logo: null, url: 'https://www.impactm.co.jp/' },
  { name: '株式会社ソニー・ミュージックアーティスツ', logo: null, url: 'https://www.sma.co.jp/' },
  { name: '北海道庁保険福祉部', logo: null, url: 'https://www.pref.hokkaido.lg.jp/' },
  { name: '双日オートグループジャパン株式会社', logo: null, url: 'https://www.sojitz-auto.co.jp/' },
];

export default function Clients() {
  const { ref: headerRef, visible: headerVisible } = useScrollReveal(0.3);
  const { ref: gridRef, visible: gridVisible } = useScrollReveal(0.1);

  return (
    <section id="clients" className="relative w-full" style={{ minHeight: '600px' }}>
      <div className="absolute inset-0">
        <img
          src="https://static.wixstatic.com/media/b08fc97db8934f8196371bbbeda5c445.jpg/v1/fill/w_1280,h_797,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/b08fc97db8934f8196371bbbeda5c445.jpg"
          alt="clients background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/65" />
      </div>

      <div className="relative z-10 w-full px-5 sm:px-8 md:px-20 py-14 md:py-20">
        {/* Section header */}
        <div ref={headerRef} className="mb-4">
          <div
            style={{
              width: headerVisible ? '32px' : '0px',
              height: '2px',
              backgroundColor: '#fff',
              marginBottom: '24px',
              transition: 'width 0.7s ease-out 0ms',
            }}
          />
          <h2
            className="text-5xl md:text-6xl font-bold text-white tracking-widest font-['Montserrat'] mb-3"
            style={animStyle(headerVisible, 'fromLeft', 150, 750)}
          >
            CLIENTS
          </h2>
          <p className="text-white/70 text-sm mb-8 md:mb-10" style={animStyle(headerVisible, 'up', 280, 600)}>
            運用実績アカウント数：100＋
          </p>
        </div>

        {/* Client logos/names grid */}
        <div
          ref={gridRef}
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-0 border-t border-l border-white/15"
        >
          {clients.map((client, idx) => (
            <a
              key={idx}
              href={client.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center p-4 sm:p-6 border-r border-b border-white/15 bg-white/5 hover:bg-white/15 transition-all duration-300 cursor-pointer"
              style={{
                minHeight: '90px',
                ...animStyle(gridVisible, 'scale', idx * 50, 550),
              }}
            >
              <span className="text-white/80 text-xs sm:text-sm font-medium text-center leading-snug tracking-wide hover:text-white transition-colors duration-300 font-['Noto_Sans_JP']">
                {client.name}
              </span>
            </a>
          ))}
        </div>

        {/* Additional note below grid */}
        <p
          className="mt-5 text-white/50 text-xs sm:text-sm font-light tracking-wider font-['Noto_Sans_JP'] text-left"
          style={animStyle(gridVisible, 'up', clients.length * 30, 600)}
        >
          ・・・この他導入企業多数実績あり
        </p>
      </div>
    </section>
  );
}
